import { Appointment } from '@models/appointments/appointment';
import { ClinicForm } from '@models/forms/clinic-form';
import { ServiceTemplateForm } from './service-template-form';

export class AppointmentForm {
  public id: number;
  public clinicFormId: number;
  public clinicForm: ClinicForm;
  public appointmentId: number;
  public appointment: Appointment;
  public formDefinition: string;
  public formEntry: string;
  public rendererVersion: string;
  public createdDate: Date;
  public modifiedDate: Date;

  public static fromForm(serviceTemplateForm: ServiceTemplateForm) {
    let appointmentForm = new AppointmentForm();
    appointmentForm.clinicFormId = serviceTemplateForm.clinicFormId;
    appointmentForm.clinicForm = serviceTemplateForm.clinicForm;
    appointmentForm.formDefinition = serviceTemplateForm.clinicForm.formDefinition;

    return appointmentForm;
  }

  public constructor(init?: Partial<AppointmentForm>) {
    Object.assign(this, init);
  }
}
